import React, { Component } from 'react';
import { connect } from 'react-redux';
import redux from '../redux';
import axios from 'axios';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import * as helpers from '../../helpers';
import Step from './components/Step';
import Summary from './components/Summary';
import QuoteFlowFormLoader from './components/QuoteFlowFormLoader';
import moment from 'moment';
// RS 2022-06-01 ADO ADO 6865 - Add Date picker content
import 'moment/locale/fr';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';
 //RS: 2022-05-30 - ADO 6865 - Use the language
i18n.on('initialized', function(options) {
  const { t, i18n } = useTranslation();
})

// hack to get FF to rerun JavaScript when the back button is pressed. Otherwise the loading screen is still visible when the back button is pressed.
window.onunload = function () { };

class QuoteFlowForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      busy: false,
      inError: false,
      loading: false,
      servicabilityParamChanged: null,
      manualErrors: {},
      startAnimating: false,
      startOfMonth: moment()
    }

    this.userInteractionInitiated = false;
    this.completedSteps = [];
    this.activeSteps = [0];

    this.setOnScroll();
    this.setOnWindowResize();
  }

  getWindowSize = () => {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      windowSize = {
        height: w.innerHeight || e.clientHeight || g.clientHeight,
        width: w.innerWidth || e.clientWidth || g.clientWidth
      };

    return windowSize;
  }

  setOnScroll = () => {
    window.addEventListener("scroll", () => {
      var targetElement = document.querySelector('.quoteFlowStep5');
      if (this.getWindowSize().width > 767) {
        this.adjustSummaryBoxState();
      }
      // Show or hide live person banner
      var bounding = targetElement.getBoundingClientRect();
      var banner = document.querySelector('.LPMcontainer.LPMtoaster');
      if (banner && targetElement) {
        if (bounding.top <= (window.innerHeight || document.documentElement.clientHeight)) {
          banner.classList.add('hide');
        } else {
          banner.classList.remove('hide');
        }
      }
    });
  }

  setOnWindowResize = () => {
    window.addEventListener("resize", () => {
      this.adjustSummaryBoxState();
    })
  }

  adjustSummaryBoxState = () => {
    const summaryBox = document.querySelector('.quote-flow__summary-box');
    if (this.getWindowSize().width <= 767) {
      summaryBox.style.top = 'calc(100% - 64px)';
      return
    }
    const firstFormStep = document.querySelector('.quoteFlowStep0'),
      summaryBoxPosition = (summaryBox ? summaryBox.getBoundingClientRect() : { bottom: 0, height: 0, left: 0, right: 0, top: 0, width: 0, x: 0, y: 0 }),
      scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
      mainContainer = document.querySelector('main'),
      min = 80,
      max = mainContainer.getBoundingClientRect().height - summaryBoxPosition.height;
    summaryBox.style.top = Math.max(min, Math.min(40 + scrollTop, max)) + 'px';
    document.body.classList.remove('quote-flow__summary-box-open');
  }

  componentDidMount() {
	  this.setLoadingOnOff(false);
	
    document.querySelector('body').classList.remove('quoteflow-form__fixed-footer');

		this.props
			.setQuoteFlowData(window.quoteFlowContent)
			.then(() => {
				const initialStepSetup = true;
				const servicabilityStatus = sessionStorage.getItem('pods-quoteflow-status');
				const servicabilityStatusCode = sessionStorage.getItem('pods-quoteflow-status-code');
				
				console.log('SERVICEABILITY STATUS', servicabilityStatus);

				if (servicabilityStatus && servicabilityStatusCode && !(servicabilityStatusCode >= 200 && servicabilityStatusCode < 300) && (servicabilityStatus != "CityServiceQualifier" || servicabilityStatus != "IFCityServiceQualifier")) {
					this.setState({ inError: true });
				}
				
				this.setActiveCompletedSteps(initialStepSetup);
			
				this.checkForCookiedAvailableDates();
				this.adjustSummaryBoxState();
				this.LoadLegacyLoading();
			}
		);
  }

  setActiveCompletedSteps = (initialSet = false) => {
    const steps = this.props.getQuoteFlowData.Steps;
    steps.map((step, stepIndex) => {
      this.setCompletedStep(step, stepIndex, initialSet);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkForInitialServicabilityValues();
    this.removeReduxFieldValuesHidddenByRules(prevProps);
    this.checkForServiceTypeChange(prevProps, prevState);
    this.setFormCookie();
  }

  checkForServiceTypeChange = (prevProps, prevState) => {
    const previousServiceType = prevProps.getQuoteFormValues.serviceType,
      currentServiceType = this.props.getQuoteFormValues.serviceType;

    if (typeof previousServiceType != "undefined" && previousServiceType != currentServiceType) {
      const steps = this.props.getQuoteFlowData.Steps,
        dateStepIsActive = this.activeSteps.indexOf(steps.findIndex(step => step.ID === "datestep")),
        contactInformationStepIsActive = this.activeSteps.indexOf(steps.findIndex(step => step.ID === "contactinformationstep"));
      let tempObj = {};

      switch (currentServiceType.toString()) {
        case "1":
          // if user changes to moving and Destination Zip isn't populated, put it in error state
          if (dateStepIsActive > -1 && !this.props.getQuoteFormValues.destinationZipCode) {
            this.setState({ manualErrors: { ...this.state.ManualErrors, destinationZipCode: true } })
          }
          this.props.getQuoteFormValues.originZipCode = this.props.getQuoteFormValues.destinationZipCode = null;
          break;
        case "2":
          // if user changes to storage and when step is active and Duration isn't populated, put it in error state.
          // if storage location step is active and location isn't populated, put it in error state
          if (dateStepIsActive > -1 && !this.props.getQuoteFormValues.duration) {
            tempObj.duration = true;
          }
          if (contactInformationStepIsActive > -1 && !this.props.getQuoteFormValues.storingLocation) {
            tempObj.storingLocation = true;
          }
          this.setState({ manualErrors: { ...this.state.ManualErrors, ...tempObj } });
          this.updateWarehouseStorageStatus();
          this.props.getQuoteFormValues.originZipCode = null;
          break;
        case "3":
          // if user changes to movingandstorage and Destination Zip isn't populated, put it in error state
          // if when step is active and Duration isn't populated, put it in error state.
          // if storage location step is active and location isn't populated, put it in error state
          if (dateStepIsActive > -1 && !this.props.getQuoteFormValues.destinationZipCode) {
            tempObj.destinationZipCode = true;
          }
          if (dateStepIsActive > -1 && !this.props.getQuoteFormValues.duration) {
            tempObj.duration = true;
          }
          if (contactInformationStepIsActive > -1 && !this.props.getQuoteFormValues.storingLocation) {
            tempObj.storingLocation = true;
          }
          this.setState({ manualErrors: { ...this.state.ManualErrors, ...tempObj } });
          this.updateWarehouseStorageStatus();
          this.props.getQuoteFormValues.originZipCode = this.props.getQuoteFormValues.destinationZipCode = null;
          break;
      }
    }
  }

  checkForCookiedAvailableDates = () => {
    let cookiedAvailableDates = sessionStorage.getItem('pods-generalAvailabilityDates');
    if (cookiedAvailableDates) {
      this.props.setAvailabilityDates(JSON.parse(cookiedAvailableDates));
    }
  }

  checkForInitialServicabilityValues = () => {
    this.props.getServicabilityParams.map((key) => {
      if (this.props.getQuoteFormValues[key] && (this.props.getQuoteFormRegisteredFields[key] || key.toLowerCase().indexOf('city') > -1)) {
        if (this.props.getQuoteFormValues[key] !== null && typeof this.props.getQuoteFormValues[key] === 'object') {
          this.props.addAddressOptions(key, [{ "Label": `${this.props.getQuoteFormValues[key].City}, ${this.props.getQuoteFormValues[key].State}`, "Value": JSON.stringify(this.props.getQuoteFormValues[key]), "Selected": true }]);
        }
      }
    })
  }

  render() {
    if (Object.keys(this.props.getQuoteFlowData).length === 0) {
      return null;
    }

    let formProps = {};

    if (this.props.getQuoteFlowData.PostFormToUrl) {
      formProps = {
        action: this.props.getQuoteFlowData.FormSubmissionUrl,
        method: "post",
        onSubmit: this.handleFormSubmit
      };
    }

    const steps = this.props.getQuoteFlowData.Steps;

    return (
      <div className={`${this.state.loading ? 'quoteFlowHolderLoading' : null} quoteFlowHolder`}>
        <QuoteFlowFormLoader startAnimating={this.state.startAnimating} />
        <div className={`quote-flow-form__mask ${this.state.busy ? 'busy' : null}`}></div>
        <div className="row no-gutters quoteFlow__form-holder">
          <form
            autoComplete="false"
            {...formProps}
            className={`col-12 quoteFlowForm quoteFlowPath${this.getQuoteFlowPath()} `}
          >
            <div className="row no-gutters">
              <div className={`col-md-6 offset-md-1 quoteFlow__${this.state.servicabilityParamChanged}__changed`}>
                {this.renderSteps(steps)}
              </div>
              <div className="col-md-4 col-lg-3 offset-lg-1">
                {this.renderSummary(steps)}
              </div>
            </div>
          </form>
          {(this.state.busy) &&
            <div className="quoteFlow__loading-spinner">
            </div>
          }
        </div>
      </div>
    )
  }

  renderSummary = (steps) => {
    const numberOfFieldsInError = Object.keys(this.props.getQuoteFormErrors).length;
    return (
      <div className={`quote-flow__summary-box ${this.state.summaryFixed ? 'quote-flow__summary-position-fixed' : 'quote-flow__summary-position-static'}`} >
        <div className={`quote-flow__summary-box__items`}>
          <h5>{this.props.getQuoteFlowData.SidebarHeader}</h5>
          <Summary
            steps={steps}
            quoteFormValues={this.props.getQuoteFormValues}
            isStepActive={this.isStepActive}
            getStepVisibleFieldCount={this.getStepVisibleFieldCount}
            stepIsCompleted={this.stepIsCompleted}
          />
        </div>
        <div className="quote-flow__summary-box__submit d-flex justify-content-between align-items-center">
          <div className="quote-flow__sumary-box-left d-flex align-items-center justify-content-center">
            <h5>{this.props.getQuoteFlowData.SidebarHeader}</h5>
            <div className="quote-flow__summary-box__toggle" onClick={this.toggleSummaryBoxOpenState}><img src="/Assets/images/icon-arrow.svg" alt="arrow" /></div>
          </div>
          <button
            onClick={this.setLoadingOnOff}
            className="btn btn-primary"
            type="submit"
            disabled={numberOfFieldsInError || this.props.submitting || this.state.inError}
          >{this.props.getQuoteFlowData.GetQuote}</button>
        </div>
      </div>
    )
  }

  renderSteps = (steps) => {
    return steps.map((step, index) => {
      let stepKey = step.Title ? step.Title.replace(/[^a-z0-9+]+/gi, '').toLowerCase() : `step${index}`;
      if (this.stepHasNoValidFields(step)) {
        return null;
      }
      return (
        <Step
          formValues={this.props.getQuoteFormValues}
          activeStep={this.getActiveStepClass(step)}
          key={stepKey}
          stepIndex={index}
          step={step}
          Field={Field}
          quoteFlowPath={this.getQuoteFlowPath()}
          availabilityDates={this.props.getQuoteFlowData.availabilityDates}
          submitting={this.props.submitting}
          handleFieldChange={this.handleFieldChange}
          zipCodeValidator={this.zipCodeValidator}
          emailValidator={this.emailValidator}
          handleMonthChange={this.handleMonthChange}
          setQuoteFlowFormFieldValue={this.setQuoteFlowFormFieldValue}
          getStepVisibleFieldCount={this.getStepVisibleFieldCount}
          manualErrors={this.state.manualErrors}
          startOfMonth={this.state.startOfMonth}
        />
      );
    });
  }

  getQuoteFlowPercentageFinished = () => {
    if (Object.keys(this.props.getQuoteFormErrors).length === 0) {
      return '100%';
    }
    return `${Math.ceil(this.completedSteps.length / this.props.getQuoteFlowData.Steps.length * 100)}%`;
  }

  toggleSummaryBoxOpenState = () => {
    document.body.classList.toggle('quote-flow__summary-box-open');
  }

  setQuoteFlowFormFieldValue = (fieldName, value) => {
    this.props.setQuoteFlowFormFieldValue(fieldName, value);
  }

  zipCodeValidator = (zipCode) => {
    let zipRegex = new RegExp(this.props.getQuoteFlowData.ZipcodeValidationRegex);
    return (zipRegex.test(zipCode) && zipCode.length > 0);
  }

  emailValidator = (email) => {
    var emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if ($("input[name='emailAddress']").hasClass("emailValidation")){
      emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }
    return (emailRegex.test(email) && email.length > 0);
  }

  handleFieldChange = (field, step, input, stepIndex) => {
    console.log(step.ID);
    this.userInteractionInitiated = true;
    if (input && input.InputType === "radioLink") {
      this.handleRedirect(field.value);
    }
    //AV - The logic for emailAddress below was only written because we couldn't find a better way to change the Hidden Field values with this codebase. Putting this logic
    //on the form submit resulted in the values not being saved before the user was redirected to the City Service Check Page. If you can find a better way to do this, please
    //feel free to refactor this approach.
    if (field && field.name && field.name == "emailAddress" && this.emailValidator(field.value)) {
      if (this.props.getQuoteFormValues.selectedDate != sessionStorage.getItem('selectedDate')) {
        var sevenFootDates = JSON.parse(sessionStorage.getItem('pods-sevenFootAvailabilityDates'));
        var twelveFootDates = JSON.parse(sessionStorage.getItem('pods-twelveFootAvailabilityDates'));
        var sixteenFootDates = JSON.parse(sessionStorage.getItem('pods-sixteenFootAvailabilityDates'));

        var selectedDateUTCValue = new Date(Date.UTC(new Date(this.props.getQuoteFormValues.selectedDate).getUTCFullYear(), new Date(this.props.getQuoteFormValues.selectedDate).getUTCMonth(), new Date(this.props.getQuoteFormValues.selectedDate).getUTCDate()));
        for (var i in sevenFootDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(sevenFootDates[i].Date).getUTCFullYear(), new Date(sevenFootDates[i].Date).getUTCMonth(), new Date(sevenFootDates[i].Date).getUTCDate()));
          if (checkedDateUTCValue.getTime() == selectedDateUTCValue.getTime()) {
            this.props.change("hdnSevenFootIsAvailable", sevenFootDates[i].IsAvailable);
            break; //Exit the loop, we're done.
          }
        };
        for (var i in twelveFootDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(twelveFootDates[i].Date).getUTCFullYear(), new Date(twelveFootDates[i].Date).getUTCMonth(), new Date(twelveFootDates[i].Date).getUTCDate()));
          if (checkedDateUTCValue.getTime() == selectedDateUTCValue.getTime()) {
            this.props.change("hdnTwelveFootIsAvailable", twelveFootDates[i].IsAvailable);
            break; //Exit the loop, we're done.
          }
        };
        for (var i in sixteenFootDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(sixteenFootDates[i].Date).getUTCFullYear(), new Date(sixteenFootDates[i].Date).getUTCMonth(), new Date(sixteenFootDates[i].Date).getUTCDate()));
          if (checkedDateUTCValue.getTime() == selectedDateUTCValue.getTime()) {
            this.props.change("hdnSixteenFootIsAvailable", sixteenFootDates[i].IsAvailable);
            break; //Exit the loop, we're done.
          }
        };
        sessionStorage.setItem('selectedDate', this.props.getQuoteFormValues.selectedDate);
      }
    }

    if (field && field.name && field.name === "serviceType" && field.value == 2) {
      this.props.change('moveType', "Basic");
    }
    if (field && this.props.getServicabilityParams.indexOf(field.name) > -1) {
      this.handleServicabilityFieldChange(field, step);
    }
    if (field && field.name && field.name === "pavedDriveway") {
      this.setCityServiceRedirect();
    }
    if (step.ID !== "locationstep") {
      window.setTimeout(() => { this.setCompletedStep(step, stepIndex) }, 350);
    }

    if(step.ID == "datestep") {
      // JW:2021-06-02 - ADO:4706 - this code needed to be moved out to handleServicabilityResponse
      setTimeout(() => {
        var generalDates = JSON.parse(sessionStorage.getItem('pods-generalAvailabilityDates'));
        var selectedDateUTCValue = new Date(Date.UTC(new Date(this.props.getQuoteFormValues.selectedDate).getUTCFullYear(), new Date(this.props.getQuoteFormValues.selectedDate).getUTCMonth(), new Date(this.props.getQuoteFormValues.selectedDate).getUTCDate()));
        sessionStorage.setItem('pods-selectedDate', this.props.getQuoteFormValues.selectedDate);

        if (window.location.href.indexOf("/fr") > -1 && (this.props.getQuoteFormValues.selectedDate_display != null)) {
          moment.locale('en');
          const selectedDate = moment(new Date(this.props.getQuoteFormValues.selectedDate));
          this.props.change('selectedDate', selectedDate.format('LL'));
          this.props.change('selectedDate_display', selectedDate.format('LL'));
          moment.locale('fr');
        }
        else if  (this.props.getQuoteFormValues.selectedDate_display != null) {
          this.props.change('selectedDate', moment(new Date(this.props.getQuoteFormValues.selectedDate)).format('LL'));
          this.props.change('selectedDate_display', moment(new Date(this.props.getQuoteFormValues.selectedDate)).format('LL'));
        }

        for (var i in generalDates) {
          var checkedDateUTCValue = new Date(Date.UTC(new Date(generalDates[i].Date).getUTCFullYear(), new Date(generalDates[i].Date).getUTCMonth(), new Date(generalDates[i].Date).getUTCDate()));
          //RS: 2023-03-08 - Check for previous storage status, don't change it if the value was set by the postal code exception
          let warehouseStorageStatus = sessionStorage.getItem('pods-warehouseStorageStatus');
          if (checkedDateUTCValue.getTime() == selectedDateUTCValue.getTime()) {
            if ((generalDates[i].LocalSalesBlocked) || (warehouseStorageStatus == 1)) {
              sessionStorage.setItem('pods-warehouseStorageStatus', 1);
            }
            else if (warehouseStorageStatus == 2) {
              sessionStorage.setItem('pods-warehouseStorageStatus', 2);
            }
            else if ((warehouseStorageStatus == 3)) {
              sessionStorage.setItem('pods-warehouseStorageStatus', 3);
            }
            else {
              sessionStorage.setItem('pods-warehouseStorageStatus', 0);
            }
            this.updateWarehouseStorageStatus();
            break; //Exit the loop, we're done.
          }
        };
      }, 200);
    }
  }

  updateWarehouseStorageStatus = () => {
    const sessionStorageStatus = sessionStorage.getItem('pods-warehouseStorageStatus');
    const sessionStorageLabel = sessionStorage.getItem('NoStorageAvailableLabel');
    const warehouseStorageStatus = parseInt(sessionStorageStatus ? sessionStorageStatus : 0);
    const noStorageAvailableLabel = sessionStorageLabel ? sessionStorageLabel : "";
    const serviceType = parseInt(this.props.getQuoteFormValues.serviceType);

    /* JW:2021-06-02 - ADO:4706 - WarehouseStorageAvailable enum reference
      WarehouseStorageAvailable = 0,
      WarehouseStorageNotAvailableAtAll = 1,
      WarehouseStorageNotAvailableForStorageOnly = 2,
      WarehouseStorageNotAvailableForMovingAndStorageOnly = 3
    */
    switch (warehouseStorageStatus) {
      case 1:
        // JW:2021-06-02 - ADO:4706 - Disable storagecenter radio/label regardless of service type selected when storage status is WarehouseStorageNotAvailableAtAll
        this.setStorageCenterAvailable(false);
        break;
      case 2:
        // JW:2021-06-02 - ADO:4706 - Disable storagecenter radio/label if service type 'Storage' is selected when storage status is WarehouseStorageNotAvailableForStorageOnly
        if (serviceType == 2) {
          this.setStorageCenterAvailable(false);
        } else {
          this.setStorageCenterAvailable(true);
        }
        break;
      case 3:
        // JW:2021-06-02 - ADO:4706 - Disable storagecenter radio/label if service type 'Moving & Storage' is selected when storage status is WarehouseStorageNotAvailableForMovingAndStorageOnly
        if (serviceType == 3) {
          this.setStorageCenterAvailable(false);
        } else {
          this.setStorageCenterAvailable(true);
        }
        break;
      default:
        this.setStorageCenterAvailable(true);
        break;
    }
  }

  setStorageCenterAvailable = (isWarehouseStorageAvailable) => {
    const sessionStorageLabel = sessionStorage.getItem('NoStorageAvailableLabel');
    const noStorageAvailableLabel = sessionStorageLabel ? sessionStorageLabel : "";
    const storageCenterInput = document.getElementById('storagecenter'); // outer, actual input
    const storageCenterRadio = document.getElementById("STORAGECENTER"); // inner, checkbox svg

    if (storageCenterInput && storageCenterRadio) {
      storageCenterInput.disabled = !isWarehouseStorageAvailable;

      if (isWarehouseStorageAvailable) {
        storageCenterRadio.classList.remove("disabled");
        if(noStorageAvailableLabel.length)
        {
          storageCenterRadio.innerHTML = storageCenterRadio.innerHTML.replace(noStorageAvailableLabel, '').trim();
        }
      } else {
        const storingLocation = this.props.getQuoteFormValues.storingLocation;
        if (storingLocation !== undefined && storingLocation !== 'onsite') {
          // JW:2021-06-02 - ADO:4706 - only change it if it's been set by the user, otherwise it opens early
          this.props.change('storingLocation', "onsite");
          document.getElementById('storagecenter').checked = false;
        }
        storageCenterRadio.classList.add("disabled");

        if (noStorageAvailableLabel.length && storageCenterRadio.innerHTML.indexOf(noStorageAvailableLabel) == -1) {
          storageCenterRadio.innerHTML += ' ' + noStorageAvailableLabel;
        }
      }
    }
  }

  addStepIndexToArray = (stepID, arrayToAddItTo) => {
    const steps = this.props.getQuoteFlowData.Steps,
      stepIndex = steps.findIndex(step => step.ID === stepID);
    if (typeof stepIndex !== 'undefined' && arrayToAddItTo.indexOf(stepIndex) === -1) {
      arrayToAddItTo.push(stepIndex);
    }
  }

  removeStepIndexFromArray = (stepID, arrayToRemoveItFrom) => {
    const steps = this.props.getQuoteFlowData.Steps,
      stepIndex = steps.findIndex(step => step.ID === stepID),
      indexToRemove = arrayToRemoveItFrom.indexOf(stepIndex);
    if (typeof stepIndex !== 'undefined' && indexToRemove > -1) {
      arrayToRemoveItFrom.splice(indexToRemove, 1);
    }
  }

  setCompletedStep = (step, stepIndex, initialSet = false) => {
    const steps = this.props.getQuoteFlowData.Steps;
    const wasStepAlreadyCompleted = this.completedSteps.indexOf(stepIndex);
    const stepIsCompleted = this.stepIsCompleted(step);
    switch (step.ID) {
      case "quotetypestep":
        if (this.props.getQuoteFormValues.quoteTypeLink) {
          this.addStepIndexToArray("quotetypestep", this.completedSteps);
          this.addStepIndexToArray("servicetypestep", this.activeSteps);
        }
        break;
      case "servicetypestep":
        if (this.props.getQuoteFormValues.serviceType) {
          const dateStepIsActive = this.completedSteps.indexOf(steps.findIndex(step => step.ID === "datestep"));

          this.addStepIndexToArray("servicetypestep", this.completedSteps);
          this.addStepIndexToArray("locationstep", this.activeSteps);
          if ((this.props.getQuoteFormValues.serviceType !== 1 && dateStepIsActive > -1) ||
            this.props.getQuoteFormValues.storingLocation
          ) {
            this.addStepIndexToArray("storagelocationstep", this.activeSteps);
          }
          if (wasStepAlreadyCompleted == -1 && !initialSet) {
            this.scrollToNextActiveStep(steps.findIndex(step => step.ID === "locationstep"))
          }
        }
        break;
      case "locationstep":
        if (stepIsCompleted) {
          this.addStepIndexToArray("locationstep", this.completedSteps);
          if (!this.state.inError) {
            this.addStepIndexToArray("datestep", this.activeSteps);
            if (wasStepAlreadyCompleted == -1 && !initialSet) {
              this.scrollToNextActiveStep(steps.findIndex(step => step.ID === "datestep"))
            }
          }
        } else {
          this.removeStepIndexFromArray("locationstep", this.completedSteps);
        }
        break;
      case "datestep":
        if (stepIsCompleted && !this.state.inError) {
          ;
          this.addStepIndexToArray("datestep", this.completedSteps);
          let nextStepID = "contactinformationstep";

          if (this.props.getQuoteFormValues.serviceType != 1) {
            nextStepID = "storagelocationstep";
          }

          if (wasStepAlreadyCompleted == -1 && !initialSet && this.activeSteps.indexOf(steps.findIndex(step => step.ID === nextStepID)) == -1) {
            this.scrollToNextActiveStep(steps.findIndex(step => step.ID === nextStepID))
          }

          this.addStepIndexToArray(nextStepID, this.activeSteps);
        } else {
          if (this.state.inError) {
            this.removeStepIndexFromArray("datestep", this.activeSteps);
          }
          if (!stepIsCompleted) {
            this.removeStepIndexFromArray("datestep", this.completedSteps);
          }
        }
        break;
      case "storagelocationstep":
        if (this.props.getQuoteFormValues.storingLocation && !this.state.inError) {
          this.addStepIndexToArray("storagelocationstep", this.completedSteps);
          if (wasStepAlreadyCompleted == -1 && !initialSet && this.activeSteps.indexOf(steps.findIndex(step => step.ID === "contactinformationstep")) == -1) {
            this.scrollToNextActiveStep(steps.findIndex(step => step.ID === "contactinformationstep"))
          }
          this.addStepIndexToArray("contactinformationstep", this.activeSteps);
        } else if (this.state.inError) {
          this.removeStepIndexFromArray("storagelocationstep", this.activeSteps);
        }
        break;
      case "contactinformationstep":
        if (stepIsCompleted && !this.state.inError) {
          this.addStepIndexToArray("contactinformationstep", this.completedSteps);
        } else if (this.state.inError) {
          this.removeStepIndexFromArray("contactinformationstep", this.activeSteps);
        }
        break;
    }

    this.props.setCompletedSteps(this.completedSteps, this.activeSteps);
  }

  fieldIsVisiblePopulatedAndNotInError = (input) => {
    return typeof this.props.getQuoteFormValues[input.Name] !== 'undefined' && this.props.getQuoteFormValues[input.Name] !== null && this.fieldIsVisible(input) && (!this.props.getQuoteFormErrors[input.Name] || input.InputType === "radio");
  }

  stepIsCompleted = (step) => {
    let stepIsCompleted = false;
    const numberOfRequiredVisibleFieldsInStep = step.Input.filter(input => this.fieldIsVisible(input) && input.Required).length;
    const numberOfCompletedRequiredFieldsInStep = step.Input.filter(input => this.fieldIsVisiblePopulatedAndNotInError(input) && input.Required).length;

    const numberOfVisibleFieldsInStep = step.Input.filter(input => this.fieldIsVisible(input)).length;
    const numberOfCompletedVisibleFieldsInStep = step.Input.filter(input => this.fieldIsVisiblePopulatedAndNotInError(input)).length;

    if ((numberOfRequiredVisibleFieldsInStep && numberOfRequiredVisibleFieldsInStep - numberOfCompletedRequiredFieldsInStep === 0) || (numberOfCompletedVisibleFieldsInStep === numberOfVisibleFieldsInStep)) {
      stepIsCompleted = true;
    }
    return stepIsCompleted;
  }

  getStepIndex = (stepToFind) => {
    if (stepToFind) {
      let stepIndex = null;
      this.props.getQuoteFlowData.Steps.map((step, index) => {
        if (step.Title === stepToFind.Title) {
          stepIndex = index;
        }
      });
      return stepIndex;
    }
  }

  getNextActiveStepAfterThisStep = (stepIndex) => {
    const steps = this.getVisibleSteps();
    for (let x = 0; x < steps.length; x++) {
      let actualStepIndex = this.getStepIndex(steps[x]);
      if (this.getStepVisibleFieldCount(steps[x]) > 0 && this.activeSteps.indexOf(actualStepIndex) === -1 && this.completedSteps.indexOf(this.getStepIndex(steps[x - 1])) > -1) {
        return actualStepIndex;
      }
    }
    return null;
  }

  getVisibleSteps = () => {
    return this.props.getQuoteFlowData.Steps.filter(step => step.Input.filter(input => input.HideWhen !== this.getQuoteFlowPath()).length > 0);
  }


  removeReduxFieldValuesHidddenByRules = (prevProps) => {
    // Some fields on the form are hidden based on the service type.  If you're moving, thern there is a destination and origin zipcode, as an example.
    // In Redux Form, if a field is present on the form and filled out, the value will remain in state, even though the field is no longer registered
    // The upshot is, if a user does the following
    //        1. Chooses moving
    //        2. Fills out Origin and Destination Zip ZipCode
    //        3. Changes their mind and switches to just storage
    // Then Redux Form and React will automatically remove the destination zip code and destination city from the form, but the value of those fields will renderModalActionButton
    // Which is the long way of saying that this function manually removes the orphan values
    const quoteFormValues = this.props.getQuoteFormValues,
      quoteFormValuesKeys = Object.keys(quoteFormValues),
      registeredFields = this.props.getQuoteFormRegisteredFields,
      initialValues = this.props.getQuoteFormInitialValues;
    if (Object.keys(registeredFields).length > 0) {
      for (let i = 0; i < quoteFormValuesKeys.length; i++) {
        if (!registeredFields[quoteFormValuesKeys[i]] && quoteFormValues[quoteFormValuesKeys[i]]) {
          this.props.setQuoteFlowFormFieldValue(quoteFormValuesKeys[i], null);
          if (typeof this.props.getServicabilityParams[quoteFormValuesKeys[i]] !== 'undefined' && quoteFormValuesKeys[i].toLowerCase().indexOf('city')) {
            this.props.addAddressOptions(quoteFormValuesKeys[i], []);
          }
          break;
        }
      }
    }
  }

  setBusyState = (makeBusy = true, callback = () => { }) => {
    this.setState({ busy: makeBusy }, () => {
      this.turnKeysOffOn(makeBusy);
      callback();
    });
  }

  turnFormFieldsOffOn = (makeBusy) => {
    for (let i = 0; i < document.forms[0].length; i++) {
      if (document.forms[0].elements[i].type !== 'submit') {
        document.forms[0].elements[i].disabled = makeBusy;
      }
    }
  }

  preventDefaultBehavior = (event) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };


  turnKeysOffOn = (makeBusy) => {
    if (makeBusy) {
      document.addEventListener('keydown', this.preventDefaultBehavior);
    } else {
      document.removeEventListener('keydown', this.preventDefaultBehavior);
    }
  }

  servicabilityCheck = (field, step) => {
    this.setChangedParam(field.name);
    this.setState({ inError: false }, () => {
      this.setState({ startOfMonth: moment() }, () => {
        window.focus();
        this.setBusyState(true);
        let paramValue = field.value;
        if ((typeof paramValue === "object") && (paramValue !== null)) {
          paramValue = JSON.parse(paramValue);
        }
        window.setTimeout(() => {
          this.props.postData(this.getServicabilityValues(), step.ServiceUrl, field.name).then((response) => {
            if (response.status === 200) {
              this.handleServicabilityResponse(response.data, step);
            } else {
              this.setBusyState(false, () => {
                console.log(response);
                // handle error response
              });
            }
          });
        }, 200);
      });
    });
  }

  getServicabilityValues = (ReferenceDate = null) => {
    let servicabilityValues = {
      serviceType: this.props.getQuoteFormValues.serviceType,
      QuoteFlowDatasourceId: this.props.getQuoteFormValues.quoteFlowDatasourceId
    };

    this.props.getServicabilityParams.forEach((paramName) => {
      if (paramName !== "ReferenceDate") {
        servicabilityValues[paramName] = this.props.getQuoteFormErrors[paramName] ? null : this.props.getQuoteFormValues[paramName];
      } else {
        if (ReferenceDate) {
          servicabilityValues[paramName] = ReferenceDate
        } else {
          let currentlySelectedDate = this.props.getQuoteFormValues.selectedDate;
          if (currentlySelectedDate) {
            servicabilityValues[paramName] = moment(currentlySelectedDate).startOf('month').format('YYYY-MM-DD');
          } else {
            servicabilityValues[paramName] = moment().add(1, 'days').format("YYYY-MM-DD");
          }
        }
      }
    });
    if (servicabilityValues.destinationZipCode && !servicabilityValues.originZipCode) {
      servicabilityValues.originZipCode = servicabilityValues.destinationZipCode;
    }
    try { servicabilityValues.originCity = JSON.parse(servicabilityValues.originCity); } catch (e) { }
    try { servicabilityValues.destinationCity = JSON.parse(servicabilityValues.destinationCity); } catch (e) { }
    //RS: 2022-04-28 - ADO 6392 - Return Cloud API toggle
    var UseCloudAPI = $("input[name='UseCloudAPI']").val();
    servicabilityValues.UseCloudAPI = UseCloudAPI;
    servicabilityValues.CustomerType = this.props.getQuoteFormValues.quoteType;
    return servicabilityValues;
  }


  setChangedParam = (param) => {
    this.setState({ servicabilityParamChanged: param });
  }

  handleServicabilityFieldChange = (field, step) => {
    if (this.isZipCodeField(field) && !this.zipCodeValidator(field.value)) {
      let correspondingCityField = `${this.getZipPrefix(field.name)}City`;
      this.clearCity(correspondingCityField);
    } else {
      var origionZip = this.props.getQuoteFormValues.originZipCode;
      var destinationZip = this.props.getQuoteFormValues.destinationZipCode;
      if(field.name == "destinationZipCode"){
        destinationZip = field.value;
      }
      else if(field.name == "originZipCode"){
        origionZip = field.value;
      }
      if(this.props.getQuoteFormValues.serviceType == "2" || ((this.props.getQuoteFormValues.serviceType == "1" || this.props.getQuoteFormValues.serviceType == "3") && this.zipCodeValidator(origionZip) && this.zipCodeValidator(destinationZip))) {
        this.servicabilityCheck(field, step);
        console.log("Serviceability field change")
      }
    }
    sessionStorage.setItem('zip-code-trigger', field.value);
  }

  clearCity = (cityName) => {
    this.props.change(cityName, null);
    this.props.addAddressOptions(cityName, []);
  }

  getCityFieldBasedOnZipField = (zipField) => {
    return this.getZipPrefix(zipField) + "City";
  }

  handleMonthChange = (monthBeingViewed, step) => {
    window.focus();
    this.setChangedParam('ReferenceDate');
    this.setBusyState(true);
    this.setState({ startOfMonth: monthBeingViewed.startOf('month') }, () => {
      $('.react-datepicker__navigation').attr("disabled", "disabled");
      $(".react-datepicker__month").hide();
      $('.react-datepicker__month').after("<div id='loadingTBody' style='width: 100%; border: 2px solid #c6cdd4; font-weight: bold; text-align: center; padding: 5px;'><tr><td colspan='7'>Loading...</td></tr></div>");
      this.props.postData(this.getServicabilityValues(this.state.startOfMonth.format('YYYY-MM-DD')), step.ServiceUrl, 'ReferenceDate').then((response) => {
        $("#loadingTBody").remove();
        $(".react-datepicker__month").show();
        $('.react-datepicker__navigation').removeAttr("disabled");
        if (response.status === 200) {
          this.handleServicabilityResponse(response.data);
        } else {
          this.setBusyState(false, () => {
            console.log(response);
            // handle error response
          });
        }
      });
    });
  }

  getReturnedErrorValue = (servicabilityResponse) => {
    let paramChanged = this.getZipPrefix(this.state.servicabilityParamChanged);
    paramChanged = paramChanged.charAt(0).toUpperCase() + paramChanged.slice(1);
    if (servicabilityResponse.Status != "AreaOutage") {
    if (servicabilityResponse.Status == "BadZip") {
    // RS 2022-06-01 ADO ADO 6865 - Translate invalid zip error
        return i18n.t('InvalidZip')
      }
      else {
        if (servicabilityResponse[paramChanged].Value && servicabilityResponse[paramChanged].Value.length) {
          return JSON.parse(servicabilityResponse[paramChanged].Value[0].Value);
        }
      }
    }
  }

  //This is where the servicability is handled when it comes back in
  handleServicabilityResponse = (servicabilityResponse, step = null) => {
    // Clear the redirectURL session value each time
    sessionStorage.removeItem('pods-quoteflow-redirectURL');
    console.log(servicabilityResponse);
    servicabilityResponse = this.setMoveType(servicabilityResponse);
    sessionStorage.setItem('pods-warehouse-storage-status', servicabilityResponse.WarehouseStorageStatus);
    sessionStorage.setItem('pods-quoteflow-status', servicabilityResponse.Status);
    sessionStorage.setItem('pods-quoteflow-status-code', servicabilityResponse.StatusCode);
    //RS: 2022-04-28 - ADO 6392 - Enabling the redirect option so the user isn't stuck
    var pavedDriveway = document.querySelector('.pavedDriveway');
    if (!pavedDriveway.classList.contains('d-none')){
      $('.pavedDriveway').addClass('d-none');
    }
    //RS: 2023-04-05 - Direct to french pages for get a quote
    if (servicabilityResponse.StatusCode == 200 && (window.location.href.indexOf("/fr") > -1)) {
      document.forms[0].action = "/fr/booking";
    }
    else if (servicabilityResponse.StatusCode == 200 ) {
      document.forms[0].action = "/booking";
    }
    //RS: 2023-04-05 - Direct to french pages for get a quote
    var redirectURL = (window.location.href.indexOf("/fr") > -1) && servicabilityResponse.RedirectURL != null ? "/fr" + servicabilityResponse.RedirectURL : servicabilityResponse.RedirectURL;

    if (redirectURL && servicabilityResponse.StatusCode == 201)
    {
      sessionStorage.setItem('pods-quoteflow-redirectURL', redirectURL);
    }

    if ((servicabilityResponse.StatusCode >= 200 && servicabilityResponse.StatusCode < 300)) {
      this.setState({ inError: false }, () => {
        if (servicabilityResponse.GeneralAvailabilityDates) {
          this.props.setAvailabilityDates(servicabilityResponse.GeneralAvailabilityDates).then(() => {
            this.checkForInvalidSelectedDate();
          });
          sessionStorage.setItem('pods-generalAvailabilityDates', JSON.stringify(servicabilityResponse.GeneralAvailabilityDates));
          sessionStorage.setItem('pods-sevenFootAvailabilityDates', JSON.stringify(servicabilityResponse.SevenFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-twelveFootAvailabilityDates', JSON.stringify(servicabilityResponse.TwelveFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-sixteenFootAvailabilityDates', JSON.stringify(servicabilityResponse.SixteenFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-warehouseStorageStatus', JSON.stringify(servicabilityResponse.WarehouseStorageStatus));
        }
        this.updateCityFormValues(servicabilityResponse);
        this.setBusyState(false, () => {
          this.setChangedParam(null);
          if (step) {
            const stepIndex = this.getStepIndex(step);
            window.setTimeout(this.setActiveCompletedSteps, 1000);
          }
        });
        this.updateWarehouseStorageStatus();
      });
    }
    //City Service Qualifier
    else if ((servicabilityResponse.Status == "CityServiceQualifier" || servicabilityResponse.Status == "IFCityServiceQualifier")){
      sessionStorage.setItem('pods-quoteflow-redirectURL', redirectURL);
      $('.pavedDriveway.d-none').removeClass('d-none');

      var originZip = document.querySelector('.quote-flow__text-field-originZipCode label').innerText;
      $('.pavedDriveway legend').html($('.pavedDriveway legend').html().replace("{Zip}","<span id='zip'>"+originZip+"</span>"));
      if (document.querySelector('.quote-flow__text-field-destinationZipCode input') != null && document.querySelector('.quote-flow__text-field-destinationZipCode input').value) {
        var destinationZip = originZip + " & " + document.querySelector('.quote-flow__text-field-destinationZipCode label').innerText;
        console.log('destinationZip', destinationZip);
        $('#zip').text(destinationZip);
      }
      if (servicabilityResponse.Status == "IFCityServiceQualifier"){
        //RS 2023-02-15 - Set Session Storage with after hours url
        if (servicabilityResponse.IFAfterHoursURL != null) {
          sessionStorage.setItem('IF_FallbackURL', servicabilityResponse.IFAfterHoursURL);
        }
        else {
          sessionStorage.setItem('IF_FallbackURL', '/quote/long-distance-moves');
        }
        console.log(sessionStorage.getItem('IF_FallbackURL'));
        sessionStorage.setItem('IF_PostURL', "");
        document.forms[0].action = redirectURL;
      }
      else {
        sessionStorage.removeItem('IF_PostURL');
        document.forms[0].action = redirectURL;
      }
      this.setCityServiceRedirect();
      this.setState({ inError: false }, () => {
        if (servicabilityResponse.GeneralAvailabilityDates) {
          this.props.setAvailabilityDates(servicabilityResponse.GeneralAvailabilityDates).then(() => {
            this.checkForInvalidSelectedDate();
          });
          sessionStorage.setItem('pods-generalAvailabilityDates', JSON.stringify(servicabilityResponse.GeneralAvailabilityDates));
          sessionStorage.setItem('pods-sevenFootAvailabilityDates', JSON.stringify(servicabilityResponse.SevenFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-twelveFootAvailabilityDates', JSON.stringify(servicabilityResponse.TwelveFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-sixteenFootAvailabilityDates', JSON.stringify(servicabilityResponse.SixteenFootContainerAvailabilityDates));
          sessionStorage.setItem('pods-warehouseStorageStatus', JSON.stringify(servicabilityResponse.WarehouseStorageStatus));
        }
        this.updateCityFormValues(servicabilityResponse);
        this.setBusyState(false, () => {
          this.setChangedParam(null);
          if (step) {
            const stepIndex = this.getStepIndex(step);
            window.setTimeout(this.setActiveCompletedSteps, 1000);
          }
        });
        this.updateWarehouseStorageStatus();
      });
    }
    else if (servicabilityResponse.StatusCode == 500) {
      if(servicabilityResponse.Status == "Maintenance"){
        window.location.href = servicabilityResponse.RedirectURL;
      }
      else{
        const returnedErrorValue = this.getReturnedErrorValue(servicabilityResponse);
        this.gaSubmissionTracking(servicabilityResponse.Status);
        this.setState({ inError: true }, () => {
          this.clearCity(this.getCityFieldBasedOnZipField(this.state.servicabilityParamChanged));
          this.setBusyState(false, () => {
            this.props.change(this.state.servicabilityParamChanged, null);
            this.setChangedParam(null);
            let errorModal = servicabilityResponse.ErrorModal;
            this.props.setErrorModal(errorModal).then(() => {
              this.updateErrorModal(true, returnedErrorValue);
              this.checkForInvalidSelectedDate(true);
              this.setActiveCompletedSteps();
            });
          });
        });
      }
    } else {
      const returnedErrorValue = this.getReturnedErrorValue(servicabilityResponse);
      this.setState({ inError: true }, () => {
        this.setBusyState(false, () => {
          this.props.change(this.state.servicabilityParamChanged, null);
          this.setChangedParam(null);
          this.props.setErrorModal(this.props.getQuoteFlowData.GeneralErrorModal).then(() => {
            this.updateErrorModal(true, returnedErrorValue);
            this.setActiveCompletedSteps();
          });
        });
      });
    }
  }

  checkForInvalidSelectedDate = (removeDate = false) => {
    if (this.props.getQuoteFormValues.selectedDate) {
      const selectedDateIsInvalid = this.props.getQuoteFlowData.availabilityDates.find(availabilityDate => moment(availabilityDate).format('YYYY-MM-DD') === moment(this.props.getQuoteFormValues.selectedDate).format('YYYY-MM-DD'));
      if (selectedDateIsInvalid || removeDate) {
        this.props.change('selectedDate', null);
        this.props.change('selectedDate_display', null);
      }
    }
  }

  setMoveType = (details) => {
    if (details.Status && details.Status.includes("IF")) {
      this.props.change('moveType', "IF");
      sessionStorage.setItem('IF_PostURL', details.RedirectURL);
      details.RedirectURL = "";
    }
    switch (details.Status) {
      case "IFMove":
        break;
      case "IFPriceDisplay":
      case "IFNoPrice":
      case "IFLP":
      case "IFNBF":
      case "IFCityServiceQualifier":
        if (this.isThisaCommercialQuote()) {
          break;
        }
        this.props.change('moveType', "IFNP");
        break;
      case "IFCommercialMove":
        if (this.isThisaCommercialQuote()) {
          this.props.change('moveType', "COMMIF");

          this.props.getBookingFlowSettings().then((response) => {
            sessionStorage.setItem('IF_CommercialReloPostURL', response.data.CommercialReloIFPriceDisplay.ContainerSelectorURL);
            sessionStorage.setItem('IFPriceDisplay_CommercialReloCodes', response.data.CommercialReloIFPriceDisplay.ReloPromos);
          });
          break;
        }
      default:
        this.props.change('moveType', "Basic");
    }

    return details;
  }

  updateErrorModal = (isInError, returnedErrorValue) => {
    // Note that this is returning markup as a string and not as JSX.  That's on purpose because it's using the non-react modal object
    if (this.props.getQuoteFlowData.errorModal) {
      const { errorModal } = this.props.getQuoteFlowData;
      const zipCodeTrigger = sessionStorage.getItem('zip-code-trigger');
      const responseStatus = sessionStorage.getItem('pods-quoteflow-status');

      const modalMarkup = `<div class="quote-flow-form__error-modal">
          <div class="quote-flow-form-error-modal-scroll-area">
            <div class="quote-flow-form__error-modal__header">
              ${this.renderModalHeading(errorModal, responseStatus, returnedErrorValue, zipCodeTrigger)}
            </div>
            <div class="quote-flow-form__error-modal__body">
              ${errorModal.Body}
            </div>

            ${this.renderModalActionButton(errorModal)}
            ${this.renderPhoneNumber(errorModal)}
          </div>
          ${this.renderCancelText(errorModal)}
        </div>`;
      document.activeElement.blur();
      window.setTimeout(() => {
        if (window.podsPage === undefined) {
          console.log('window.podsPage is undefined');
          return;
        }

        // adding slight delay to allow dom to catch up and actually blur the active element, to remove annoying chrome issue where autocomplete option is higher z-index than modal
        window.podsPage.modal.populateContentModalWithMarkup(modalMarkup);
      }, 50);
    }
  }

  renderModalHeading = (errorModal, responseStatus, returnedErrorValue, modalZip) => {
    let headingString = '';
    if (responseStatus == "AreaOutage") {
      headingString = `<h3>${errorModal.Header}</h3>`;
    } else {
      headingString = `<h4>${errorModal.Header}</h4>`;
      //RS-2022-05-06-ADO:6542-Add Bad Zip response to only return the zip code
      if (responseStatus == "BadZip") {
        headingString += `<h3>${modalZip}</h3>`;
      }
      else if (returnedErrorValue) {
        headingString += `<h3>${returnedErrorValue.City + ", " + returnedErrorValue.State + " " + modalZip}</h3>`;
      }
      else {
        headingString += `<h3>${modalZip}</h3>`;
      }
    }
    return headingString;
  }

  renderPhoneNumber = (errorModal) => {
    // Note that this is returning a string and NOT JSX.  That's on purpose
    let phoneNumberString = '';
    if (errorModal.PhoneNumberText) {
      phoneNumberString = `${errorModal.PhoneNumberText}`;
    }
    if (errorModal.PhoneNumberValue) {
      phoneNumberString = `<a href="tel:${errorModal.PhoneNumberValue}">${phoneNumberString}</a>`;
    }
    if (errorModal.Or && errorModal.PhoneNumberText && errorModal.ActionUrl) {
      phoneNumberString = `<p>${errorModal.Or}</p>${phoneNumberString}`;
    }
    return phoneNumberString;
  }

  renderModalActionButton = (errorModal) => {
    // Note that this is returning a string and NOT JSX.  That's on purpose
    if (errorModal.ActionUrl) {
      return `
        <div class="quote-flow-form__modal__action-holder">
          <a class="btn btn-primary" href="${errorModal.ActionUrl}">${errorModal.ActionLabel}</a>
        </div>
      `;
    }
    return '';
  }

  renderCancelText = (errorModal) => {
    // Note that this is returning a string and NOT JSX.  That's on purpose
    if (errorModal.CancelLabel) {
      return `
        <div class="quote-flow-form__modal__cancel-holder">
          ${errorModal.CancelLabel}
        </div>
      `;
    }
    return '';
  }
  // This is where the content changes to grab new information
  updateCityFormValues = (response) => {
    if (this.state.servicabilityParamChanged === "originZipCode" || this.props.getQuoteFormValues.serviceType == "1" || this.props.getQuoteFormValues.serviceType == "3") {
      if (response.Origin.Value && response.Origin.Value.length === 1) {
        const OriginCity = JSON.parse(response.Origin.Value[0].Value);
        if (this.shouldCityParamBeUpdated('originCity', OriginCity)) {
          this.props.change('originCity', OriginCity || {});
        }
      }
    }
    if (this.state.servicabilityParamChanged === "destinationZipCode"|| this.props.getQuoteFormValues.serviceType == "1" || this.props.getQuoteFormValues.serviceType == "3") {
      if (response.Destination.Value && response.Destination.Value.length === 1) {
        const DestinationCity = JSON.parse(response.Destination.Value[0].Value);
        if (this.shouldCityParamBeUpdated('destinationCity', DestinationCity)) {
          this.props.change('destinationCity', DestinationCity || {});
        }
      }
    }
  }

  shouldCityParamBeUpdated = (cityType, city) => {
    if (!this.props.getQuoteFormValues[cityType] ||
      Object.keys(this.props.getQuoteFormValues[cityType]).length === 0 ||
      (this.props.getQuoteFormValues[cityType].City && this.props.getQuoteFormValues[cityType].City !== city.City)
    ) {
      return true;
    }
    return false;
  }

  getZipPrefix = (zipString) => {
    return zipString.substr(0, zipString.indexOf('ZipCode'));
  }

  isZipCodeField = (field) => {
    return field.name.toLowerCase().indexOf('zipcode') > -1;
  }

  isDefaultPromoCodeSet = () => {
    if (this.props.getQuoteFlowData.DefaultPromoCode && this.props.getQuoteFlowData.DefaultPromoCode.length > 0) {
      return true;
    }
    return false;
  }

  isSpecialIF = () => {
    if (this.props.getQuoteFormValues.moveType == "IFPD" || this.props.getQuoteFormValues.moveType == "IFNP") {
      return true;
    }
    return false;
  }

  isThisaCommercialQuote = () => {
    if (this.props.getQuoteFlowData.QuoteType && this.props.getQuoteFlowData.QuoteType.toLowerCase() === "commercial") {
      return true;
    }
    return false;
  }
  //RS 2022-12-7 - City Service redirect in case they choose YES
  setCityServiceRedirect = () => {
    var selectedValue = $('input[name=pavedDriveway]').is(":checked") ? document.querySelector('input[name=pavedDriveway]:checked').value : "no";
    var serviceType = sessionStorage.getItem('pods-quoteflow-status');
    if (selectedValue.toUpperCase() == "YES"){
      //RS 2023-02-15 - Update to use the fallback if it exists, if it doesn't, route to the long distance moves page
      if (serviceType == "IFCityServiceQualifier"){
        console.log("city service redirect");
        sessionStorage.setItem('IF_PostURL', sessionStorage.getItem('IF_FallbackURL'));
          document.forms[0].action = sessionStorage.getItem('IF_PostURL');
          sessionStorage.removeItem('pods-quoteflow-redirectURL');
      }
      else
      {
        sessionStorage.removeItem('IF_PostURL');
        document.forms[0].action = '/booking';
        sessionStorage.removeItem('pods-quoteflow-redirectURL');
      }
    }
    else {
      sessionStorage.setItem('IF_PostURL', "/city-service-moves");
      sessionStorage.setItem('pods-quoteflow-redirectURL', "/city-service-moves");
    }
  }
  handleFormSubmit = (e) => {
    this.gaSubmissionTracking(this.getSubmissionType());

    // CALL SALESFORCE API HERE
    this.props.getQuoteFormValues.selectedDate_display = sessionStorage.getItem('pods-selectedDate');
    this.props.postSalesforceLeadData(this.props.getQuoteFormValues.quoteType, this.props.getQuoteFormValues);

    if (sessionStorage.getItem('pods-quoteflow-redirectURL')) {
      e.preventDefault();
      window.location.href = sessionStorage.getItem('pods-quoteflow-redirectURL');
    }
    sessionStorage.setItem('quoteInfo', JSON.stringify(this.props.getQuoteFormValues));

    var currentPromo = this.props.getQuoteFormValues.promotionCode;
    var storageDuration = this.props.getQuoteFormValues.duration;
    if ((currentPromo && currentPromo.length > 0 || storageDuration >= 3) && this.isSpecialIF()) {
      this.props.change('moveType', "IF");
    }
    if ((this.props.getQuoteFormValues.moveType == "IFPD" || this.props.getQuoteFormValues.moveType == "IFNP"
      || this.props.getQuoteFormValues.moveType == "IF" || this.props.getQuoteFormValues.moveType == "COMMIF")
      && (sessionStorage.getItem('IF_PostURL') != null)) {

      document.forms[0].action = sessionStorage.getItem('IF_PostURL');

      if (this.props.getQuoteFormValues.moveType == "COMMIF") {
        if (currentPromo && currentPromo.length > 0) {
          var reloArray = sessionStorage.getItem('IFPriceDisplay_CommercialReloCodes').toLowerCase().split('|');
          var postURL = sessionStorage.getItem('IF_CommercialReloPostURL');

          if (postURL != null) {
            if (reloArray.includes(currentPromo.toLowerCase())) {
              document.forms[0].action = postURL;
            }
          }
        }
      }
    }

    var originCity = $("select[name='originCity']").val();
    var origionObj = JSON.parse(originCity);

    var dataLayerObj = {
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': {
            'option': 'Quote',
            'step': '1'
          },
          'products': [{
            'category': $("input[name='quoteTypeLink']:checked").parent().find('.radio-input-inner').text() == "Business" ? "Commercial" : "Residential",
            'subcategory': $("input[name='serviceType']:checked").parent().find('.radio-input-inner').text().replace("&", "and"),
            'currency': 'USD',
            'dimension9': origionObj.FranchiseeId,
            'dimension10': $("select[name='duration']").val(),
            'id': 'placeholder', //required value
            'name': 'placeholder', //required value
            'promoCodeEntered': $("input[name='promotionCode']").val(),
            'promoCodeApplied': $("input[name='promotionCode']").val(),
            'storingLocation': $("input[name='storingLocation']:checked").parent().find('.radio-input-inner').text(),
            'originZip': $("input[name='originZipCode']").val(),
            'destinationZip': $("input[name='destinationZipCode']").val(),
            'url': window.location.href.split('?')[0],
            'variant': 'Local'
          }]
        }
      }
    };
    dataLayer.push(dataLayerObj);
    localStorage.setItem("dataLayer", JSON.stringify(dataLayerObj));

    return this.submitToBooking();
  }

  submitToBooking = () => {
    this.postToLivePerson(this.props.getQuoteFormInitialValues["moveType"], this.props.getQuoteFormValues["emailAddress"]);
    this.ajaxPostForm(this.props.getQuoteFormValues, false);
    return true;
  }

  postToLivePerson = (moveType, emailAddress) => {
    if (moveType == "IF") {
      lpTag.sdes.push(
        {
          type: "personal",
          personal: {
            firstname: "N/A",
            lastname: "N/A",
            age: { age: 0, year: 0, month: 0, day: 0 },
            contacts: [{ email: emailAddress, phone: "N/A" }],
            gender: "",
            language: "",
            company: ""
          }
        }
      )
    }
    else {
      //Do nothing with LivePerson
    };
  }

  setLoadingOnOff = (loading = true) => {
    let startAnimating = false;
    if (loading) {
      startAnimating = true;
    }
    this.setState({ loading, startAnimating });
  }

  LoadLegacyLoading = () => {
    if(this.props.getQuoteFlowData.LoadingValues.LoadingScreenScript != null && this.props.getQuoteFlowData.LoadingValues.LoadingScreenScript != ''){
      const script = document.createElement('script');
      script.src = this.props.getQuoteFlowData.LoadingValues.LoadingScreenScript;
      document.head.appendChild(script);
    }
  }

  ajaxPostForm = (formValues) => {
    let url = this.props.getQuoteFlowData.Steps[this.props.getQuoteFlowData.Steps.length - 1].ServiceUrl;
    let getPricePostParams = this.getPriceParams(formValues);
    let THIS = this;

    this.setState({ loading: true }, () => {
      window.scroll(0, 0);
      document.body.style.overflow = 'hidden';
      axios.post(url, getPricePostParams, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        //TODO: Are we going to do anything with positive responses from GetPrice?
      })
        .catch(function (error) {
          if (redirectAfter) {
            THIS.setState({ loading: false }, () => {
              document.body.removeAttribute('style');
              THIS.props.setErrorModal(THIS.props.getQuoteFlowData.GeneralErrorModal).then(() => {
                THIS.updateErrorModal(false);
              });
            });
          }
        });
    });
  }

  getPriceParams = (formValues) => {
    let params = {};
    Object.keys(formValues).map((key) => {
      params[key] = formValues[key];
    });

    // Manually adding key values until the form data matches the post data
    params.selectedDate = formValues.startDate || formValues.selectedDate;
    params.promotionCode = formValues.promoCode || formValues.promotionCode;
    params.duration = formValues.timeFrame || formValues.duration;
    params.queryStringValues = this.getGetPriceQueryStringValues();

    try { params.originCity = JSON.parse(params.originCity); } catch (e) { }
    try { params.destinationCity = JSON.parse(params.destinationCity); } catch (e) { }

    return params;
  }

  getGetPriceQueryStringValues = () => {
    //this.props.getQuoteFlowData.queryStringKeys are currently being hardcoded in the reducer but ideally these would come from the initial form endpoint
    let queryStringValues = [];
    this.props.getQuoteFlowData.queryStringKeys.map((key) => {
      if (getURLParam(key)) {
        queryStringValues.push({ [key]: getURLParam(key) });
      }
    });
    return queryStringValues;
  }

  getQuoteFlowPath = () => {
    return this.props.getQuoteFormValues.serviceType || '1';
  }

  isStepActive = (step) => {
    if (step.active) {
      return true;
    } else {
      return false;
    }
  }

  getActiveStepClass = (step) => {
    if (this.isStepActive(step)) {
      return 'active';
    } else {
      return '';
    }
  }

  getOffset = (el) => {
    el = el.getBoundingClientRect();
    return {
      left: el.left + window.scrollX,
      top: el.top + (window.scrollY || pageYOffset)
    }
  }

  scrollToNextActiveStep = (stepIndex, callback) => {
    const activeStep = document.querySelector(`.quoteFlowStep${stepIndex}`);
    this.scrollTo(document.documentElement, this.getOffset(activeStep).top - 100, 300, callback);
  }

  scrollTo = (element, to = 10000, duration = 1000, callback) => {
    const start = element.scrollTop;
    const change = to - start;
    const increment = 20;
    let currentTime = 0;

    const animateScroll = (() => {
      currentTime += increment;

      const val = this.easeInOutQuad(currentTime, start, change, duration);

      element.scrollTop = val;

      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      } else {
        if (callback) {
          callback();
        }
      }
    });

    animateScroll();
  };

  easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  fieldIsVisible = (option) => {
    if ((option.InputType && option.InputType.toLowerCase() !== "hidden") && option.HideWhen !== this.getQuoteFlowPath()) {
      return true;
    }
    return false;
  }

  getStepVisibleFieldCount = (step) => {
    return step.Input.filter((stepInput) => stepInput.HideWhen !== this.getQuoteFlowPath()).length;
  }

  stepHasNoValidFields = (step) => {
    if (!step.Input || step.Input.length === 0 || step.Input.filter((input) => input.Name).length === 0) {
      return true;
    }
    return false;
  }

  handleRedirect = (url) => {
    if (url !== window.location.href) {
      window.location = url;
    }
  }

  setFormCookie = () => {
    sessionStorage.setItem('pods-quote-flow-form', JSON.stringify(this.props.getQuoteFormValues));
  }

  gaSubmissionTracking = (moveType = this.props.getQuoteFormValues.moveType) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      {
        "quoteType": this.props.getQuoteFlowData.QuoteType,
        "moveType": moveType,
        "originZipCode": this.props.getQuoteFormValues.originZipCode,
        "destinationZipCode": this.props.getQuoteFormValues.destinationZipCode,
        "storingLocation": this.props.getQuoteFormValues.storingLocation,
        'serviceType': this.props.getQuoteFlowData.Steps.find(step => step.ID === "servicetypestep").Input.find((input) => input.Name === "serviceType").Value.find(val => val.Value === this.props.getQuoteFormValues.serviceType).Label,
        "event": "quote_submitted"
      }
    );
  }

  getSubmissionType = () => {
    return `${this.props.getQuoteFlowData.QuoteType}_quote`;
  }
}


QuoteFlowForm = reduxForm({
  form: 'QuoteFlowForm'
})(QuoteFlowForm);


const mapDispatchToProps = (dispatch) => {
  return {
    setQuoteFlowFormFieldValue: (fieldName, value) => dispatch(change('QuoteFlowForm', fieldName, value)),
    setQuoteFlowData: (quoteFlowData) => dispatch(redux.actions.setQuoteFlowData(quoteFlowData)),
    setCompletedSteps: (completedSteps, activeSteps) => dispatch(redux.actions.setCompletedSteps(completedSteps, activeSteps)),
    addAddressOptions: (key, value, skipAddressProcessing) => dispatch(redux.actions.addAddressOptions(key, value, skipAddressProcessing)),
    postData: (stepPostParams, url, paramThatChanged) => dispatch(redux.actions.postData(stepPostParams, url, paramThatChanged)),
    setAvailabilityDates: (availabilityDates) => dispatch(redux.actions.setAvailabilityDates(availabilityDates)),
    setErrorModal: (errorModal) => dispatch(redux.actions.setErrorModal(errorModal)),
    getBookingFlowSettings: () => dispatch(redux.actions.getBookingFlowSettings()),
    postSalesforceLeadData: (customerType, quoteData) => dispatch(redux.actions.postSalesforceLeadData(customerType, quoteData))
  }
}

const mapStateToProps = (state) => {
  return {
    initialValues: { undefined, ...getInitValues() },
    getQuoteFlowData: redux.selectors.getQuoteFlowData(state),
    getQuoteFormValues: redux.selectors.getQuoteFormValues(state),
    getQuoteFormErrors: redux.selectors.getQuoteFormErrors(state),
    getQuoteFormInitialValues: redux.selectors.getQuoteFormInitialValues(state),
    getQuoteFormRegisteredFields: redux.selectors.getQuoteFormRegisteredFields(state),
    getServicabilityParams: redux.selectors.getServicabilityParams(state)
  }
}

const getURLParam = (param) => {
  const half = location.search.split(param + '=')[1];
  return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
}

let initValuesLoaded = false;

const getInitValues = () => {
  const initValues = {};
  if (!initValuesLoaded) {
    window.quoteFlowContent.Steps.map((step) => {
      step.Input.map((option) => {
        if (option.Name === "selectedDate") {
          initValues.selectedDate_display = option.Value;
        }
        if (!option.Value || option.Value.constructor !== Array) {
          initValues[option.Name] = option.Value;
        } else if (option.Value.constructor === Array) {
          option.Value.map((opt) => {
            if (opt.Selected) {
              initValues[option.Name] = opt.Value;
            }
          })
        }
      })
    });
  }

  initValuesLoaded = true;
  return initValues;
}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteFlowForm);
